/**
 * @generated SignedSource<<74ff00219f65d0537956ead28a5eaeb8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Details_company$data = {
  readonly id: string;
  readonly isUsingProjectAllocation: boolean | null;
  readonly " $fragmentType": "Details_company";
};
export type Details_company$key = {
  readonly " $data"?: Details_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"Details_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Details_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUsingProjectAllocation",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "b012cccfdfd58b5bebc8f073a4ec1d2b";

export default node;
